import {
  eTaxCertificationRequestStatus,
  vendorTaxReqInitialStatuses,
} from '../order/title/eTaxCertificationRequestStatus';
import { IVendorTaxCertificationsPagedResponse } from './IVendorTaxCertifications';

export interface ISearchOrderTaxCertReqSettingsData {
  fileNumber?: string;
  pageNumber: number;
  pageSize: number;
  statuses: eTaxCertificationRequestStatus[];
}

export const createDefaultSearchOrdersTaxReqSettingsData = (): ISearchOrderTaxCertReqSettingsData => ({
  pageNumber: 0,
  pageSize: 50,
  statuses: vendorTaxReqInitialStatuses,
});

export const convertFromVendorOrdersTaxReqResponseToSearchOrdersSettingsData = (
  data: IVendorTaxCertificationsPagedResponse,
  statuses?: eTaxCertificationRequestStatus[]
): ISearchOrderTaxCertReqSettingsData => ({
  pageNumber: data.pageable.pageNumber,
  pageSize: data.pageable.pageSize,
  statuses: statuses || vendorTaxReqInitialStatuses,
});
